import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Header from 'modules/contracts/components/ContractDetails/Section/Header'

const LoadingLine = () => {
  return (
    <Box gap="s8">
      <Skeleton width="s80" height="s8" />
      <Skeleton width="s140" height="s8" />
    </Box>
  )
}

const LoadingItem = () => {
  return (
    <Box
      gridColSpan={{ xxs: 12, xs: 6, s: 6 }}
      gap="s32"
      padding="s24"
      border={{
        all: {
          width: 's2',
          color: 'grey400',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      height="full"
    >
      <LoadingLine />
      <LoadingLine />
      <LoadingLine />
    </Box>
  )
}

const LoadingState = () => {
  return (
    <Box gap="s16" flexDirection="column" data-testid="additional-compensations-loading">
      <Header icon="payroll" title={i18n.t('contract_versions.compensation.title')} />
      <Grid variant="fixed" data-testid="loading">
        <LoadingItem />
        <LoadingItem />
      </Grid>
    </Box>
  )
}

export default LoadingState
